// useLang — język UI w React (MONIT 2026-10-02_0526). Wzorzec useTheme: stan modułowy
// w shared/i18n.js + useSyncExternalStore. Komponent, który woła t() w renderze, MUSI
// zasubskrybować język (ten hook), inaczej po przełączeniu zostanie ze starym tekstem
// do następnego renderu. App.jsx subskrybuje u korzenia (re-render całego drzewa bez
// React.memo), ten hook w komponentach to pas bezpieczeństwa + źródło `lang` do deps.

import { useCallback, useSyncExternalStore } from 'react';
import { getLang, setLang, subscribeLang, t, tp, toggleLang, langLocale } from '../shared/i18n.js';

export function useLang() {
  const lang = useSyncExternalStore(subscribeLang, getLang, () => 'pl');
  const set = useCallback((l) => setLang(l), []);
  const toggle = useCallback(() => toggleLang(), []);
  return { lang, t, tp, setLang: set, toggle, locale: langLocale(lang) };
}

export default useLang;
